import { styled } from 'css-literal-loader/styled';
import defaultProps from 'recompose/defaultProps';
import Layout from '@4c/layout';

const propTypes = {};

const Card = defaultProps({ direction: 'column' })(
  styled(Layout, null, "Card", require("./Card-Card.module.scss"), "card", "card"),
);

const CardSegment = styled(Layout, null, "CardSegment", require("./Card-CardSegment.module.scss"), "card-segment", "cardSegment");

const CardHeading = defaultProps({ display: 'block' })(
  styled(Layout, null, "CardHeading", require("./Card-CardHeading.module.scss"), "card-heading", "cardHeading"),
);

const CardBody = defaultProps({
  display: 'block',
  direction: 'column',
  grow: true,
})(
  styled(CardSegment, null, "CardBody", require("./Card-CardBody.module.scss"), "card-body", "cardBody"),
);

const CardFooter = defaultProps({ display: 'block' })(
  styled(CardSegment, null, "CardFooter", require("./Card-CardFooter.module.scss"), "card-footer", "cardFooter"),
);

Card.propTypes = propTypes;
Card.Body = CardBody;
Card.Segment = CardSegment;
Card.Heading = CardHeading;
Card.Footer = CardFooter;

export default Card;
